import { defineMessages } from 'react-intl';

export const mcpInfoCardMessages = defineMessages({
  title: {
    id: 'oauth.mcp.infoCard.title',
    defaultMessage: 'What is an MCP server?',
    description:
      'Title for the MCP informational callout on the consent screen (default/Atlassian flow)',
  },
  body: {
    id: 'oauth.mcp.infoCard.body',
    defaultMessage:
      'MCP servers are the new standard way to safely empower agents to access your data. In this step we will help you define exactly what your agent can and cannot do.',
    description:
      'Body text explaining MCP servers on the consent screen (default/Atlassian flow)',
  },
  trelloTitle: {
    id: 'oauth.mcp.infoCard.trelloTitle',
    defaultMessage: 'What is a Trello MCP server?',
    description:
      'Title for the MCP informational callout on the consent screen (Trello-only flow)',
  },
  trelloBody: {
    id: 'oauth.mcp.infoCard.trelloBody',
    defaultMessage:
      "A Trello MCP server is the secure way to connect AI agents like Claude or ChatGPT to your Trello data. In this step we'll help you define exactly what your agent can and cannot access.",
    description:
      'Body text explaining MCP servers on the consent screen (Trello-only flow)',
  },
  learnMore: {
    id: 'oauth.mcp.infoCard.learnMore',
    defaultMessage: 'Learn more',
    description: 'Link button to documentation about MCP',
  },
  sseMigrationTitle: {
    id: 'oauth.mcp.infoCard.sseMigration.title',
    defaultMessage: 'Migrate to the new endpoint',
    description: 'Title for SSE deprecation banner in MCP consent screen',
  },
  sseMigrationBody: {
    id: 'oauth.mcp.infoCard.sseMigration.body',
    defaultMessage:
      'The endpoint {endpoint} is deprecated. To keep your connection to the Atlassian Rovo MCP Server active, update your configuration to the latest version.',
    description: 'Body for SSE deprecation banner; {endpoint} is inline code',
  },
  migrationGuide: {
    id: 'oauth.mcp.infoCard.sseMigration.migrationGuide',
    defaultMessage: 'View migration guide',
    description: 'Link to migration documentation from SSE deprecation banner',
  },
  carouselRegionAriaLabel: {
    id: 'oauth.mcp.infoCard.carousel.regionAriaLabel',
    defaultMessage: 'MCP information',
    description: 'Aria label for the MCP info card carousel region',
  },
});
